import React, {useEffect, useState} from 'react';

import styles from './DeleteOrder.module.scss';

const DeleteOrder = ({id, setIsDetailedOptionsVisible, handleDeleteOrder}) => {
    const [isModalDeleteOrderOpen, setIsModalDeleteOrderOpen] = useState(true);

    const handleCancel = () => {
        setIsModalDeleteOrderOpen(false);
    }

    useEffect(() => {
        if (!isModalDeleteOrderOpen) {
            setIsDetailedOptionsVisible(false);
        }
    }, [isModalDeleteOrderOpen])

    return (
        <>
            {isModalDeleteOrderOpen ?
                <div className={styles.deleteOrder_wrapper}>
                    <div className={styles.deleteOrder}>
                        <div className={styles.deleteOrder_titleContainer}>
                            <p className={styles.deleteOrder_titleContainer_title}>Видалити замовлення</p>
                            <p className={styles.deleteOrder_titleContainer_subtitle}>
                                Ви впевнені, що хочете видалити це замовлення? Цю дію відмінити
                                не можна.
                            </p>
                        </div>

                        <div className={styles.deleteOrder_buttons}>
                            <button
                                onClick={handleCancel}
                                className={`${styles.button} ${styles.cancel}`}
                            >Відмінити
                            </button>

                            <button
                                onClick={() => handleDeleteOrder(setIsModalDeleteOrderOpen, id)}
                                className={`${styles.button} ${styles.delete}`}
                            >Видалити
                            </button>
                        </div>
                    </div>
                </div> :
                null}
        </>
    );
};

export default DeleteOrder;
